import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { useMemo } from "react";

import { MSAL_CONFIG } from "~/lib/auth";

export function AuthProvider({ children }: { children: React.ReactNode }) {
  const pca = useMemo(() => new PublicClientApplication(MSAL_CONFIG), []);
  return <MsalProvider instance={pca}>{children}</MsalProvider>;
}
